package com.iregained.site.components.sections.resources.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*


val ResourcesGridContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth()
        .backgroundColor(colorMode.toSitePalette().custom.lightGray) // Soft background to contrast cards
        .padding(topBottom = 80.px)
}

// --- PHASE 3: FILTER BAR STYLES ---
val ResourceFilterWrapperStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1200.px).padding(leftRight = 24.px, bottom = 48.px).display(DisplayStyle.Flex)
        .flexWrap(FlexWrap.Wrap).justifyContent(JustifyContent.Center).gap(16.px)
}

val ResourceFilterButtonStyle = CssStyle {
    base {
        Modifier.padding(topBottom = 10.px, leftRight = 24.px).borderRadius(50.px) // Pill shape
            .border(1.px, LineStyle.Solid, Colors.LightGray).backgroundColor(Colors.White).color(Colors.DarkSlateGray)
            .fontSize(1.cssRem).fontWeight(FontWeight.SemiBold).cursor(Cursor.Pointer)
            .transition(Transition.of("all", 200.ms))
    }
    hover {
        Modifier.border(1.px, LineStyle.Solid, colorMode.toSitePalette().brand.primary)
            .color(colorMode.toSitePalette().brand.primary)
    }
}

val ResourceFilterButtonActiveStyle = CssStyle {
    base {
        Modifier.backgroundColor(colorMode.toSitePalette().brand.primary)
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().brand.primary)
            .color(Colors.White)
    }
    hover {
        // Overrides the base button's hover effect to ensure the text stays visible
        Modifier.color(Colors.White)
    }
}

// --- PHASE 4: RESOURCE CARD STYLES ---
val ResourceCardGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1200.px).padding(leftRight = 24.px).gap(32.px)
}

val ResourceCardStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().height(100.percent) // Ensures row stretching
            .backgroundColor(Colors.White).borderRadius(16.px).border(1.px, LineStyle.Solid, Colors.LightGray)
            .padding(32.px).display(DisplayStyle.Flex).flexDirection(FlexDirection.Column).cursor(Cursor.Pointer)
            .transition(Transition.of("transform", 250.ms), Transition.of("box-shadow", 250.ms))
    }
    hover {
        Modifier.transform { translateY((-6).px) }.boxShadow(0.px, 16.px, 32.px, color = Colors.Black.copy(alpha = 8))
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().brand.primary)
    }
}

val ResourceCardHeaderStyle = CssStyle.base {
    Modifier.fillMaxWidth().display(DisplayStyle.Flex).justifyContent(JustifyContent.SpaceBetween)
        .alignItems(AlignItems.Center).margin(bottom = 24.px)
}

val ResourceBadgeStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().brand.primary)
        .backgroundColor(colorMode.toSitePalette().brand.primary.toRgb().copyf(alpha = 0.1f))
        .padding(topBottom = 4.px, leftRight = 12.px).borderRadius(6.px).fontSize(0.85.cssRem)
        .fontWeight(FontWeight.Bold).textTransform(TextTransform.Uppercase)
}

val ResourcePlainTitleStyle = CssStyle.base {
    Modifier.color(Colors.DarkSlateGray).fontSize(1.35.cssRem).fontWeight(FontWeight.Bold).lineHeight(1.3)
        .margin(bottom = 12.px)
}

val ResourceAcademicTitleStyle = CssStyle.base {
    Modifier.color(Colors.Gray).fontSize(0.95.cssRem).lineHeight(1.5)
        .fontStyle(FontStyle.Italic) // Helps differentiate the formal title
        .margin(bottom = 32.px)
}

val ResourceCardFooterStyle = CssStyle.base {
    Modifier.fillMaxWidth().display(DisplayStyle.Flex).justifyContent(JustifyContent.SpaceBetween)
        .alignItems(AlignItems.Center).margin(top = 32.px) // Pushes to the bottom
}

val ResourceDateStyle = CssStyle.base {
    Modifier.color(Colors.Gray).fontSize(0.9.cssRem).fontWeight(FontWeight.Medium)
}

val ResourceActionIconStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().brand.primary).fontSize(1.25.cssRem).fontWeight(FontWeight.Bold)
}